import { useEffect, useState } from "react";
import { Col, Form, FormGroup, Row } from "react-bootstrap"
import { MdAttachFile } from "react-icons/md"
import { FileDropzone } from "../../../../../components/dropzone-file";
import { FileViewer } from "../../../../../components/fileviewer";
import { CardDescription, SecondaryButton } from "../../../styled"

interface IFileUploadForm {
    executablePath: (path: string) => void;
    updateData: boolean;
    onAdd: (file: any) => void;
    isAdded: (bool: boolean) => void;
    itemData?: any;
    isGeneratingScorm?: boolean;
}

export const FileUploadForm: React.FC<IFileUploadForm> = ({ updateData = false, onAdd, isAdded, itemData, executablePath, isGeneratingScorm = false, })  => {

    const [fileUpload, setFileUpload] = useState<any>()

    const [isScorm, setIsScorm] = useState<boolean>(false)


    const handleFileSelected = (file: any) => {
        setFileUpload(file);
        onAdd(file);
        isAdded(true);
    }

    const handleRemoveFile = () => {
        setFileUpload(undefined);
        onAdd(undefined);
    }

    useEffect(() => {
        if (itemData) {
            setFileUpload({ 'path': itemData.url_path });
            onAdd({ 'path': itemData.url_path })
        }
    }, [itemData])

    return (
        <>
            <CardDescription>
                <div className="title mb-2" style={{ fontSize: '16px' }}><MdAttachFile fontSize={20} style={{ marginTop: '-5px' }}></MdAttachFile> Arquivo anexado</div>
                {updateData ? (<>
                    {fileUpload?.path === null || !fileUpload ? (
                        <Row className="my-4">
                            <Col md={12}>
                                <FileDropzone onSelectFile={handleFileSelected}></FileDropzone>
                            </Col>
                        </Row>
                    ) : (<></>)}

                    {fileUpload?.path !== null && fileUpload !== undefined ? (
                        <>
                            <Row>
                                <Col sm={8} md={8} lg={9} className="mb-3">
                                    <Form.Control id="file" type="text" disabled defaultValue={fileUpload?.path}></Form.Control>
                                </Col>
                                <Col sm={4} md={4} lg={3}>
                                    <SecondaryButton
                                        style={{ width: '100%', float: 'left' }}>
                                        <button name='addbutton' type='button' style={{ border: '1px solid #EC7D7D', color: '#EC7D7D' }}
                                            onClick={handleRemoveFile}>
                                            Remover
                                        </button>
                                    </SecondaryButton>
                                </Col>
                            </Row>
                            <Row className='mt-2'>
                                {fileUpload.type === 'application/x-zip-compressed' ? (
                                    <>
                                        <Col sm={12}>
                                            <FormGroup className="mb-3">
                                                <Form.Check
                                                    type="switch"
                                                    id="custom-switch"
                                                    label="Tornar executável"
                                                    defaultChecked={isScorm}
                                                    onChange={(e) => { setIsScorm(!isScorm) }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        {isScorm && (
                                            <Col sm={12}>
                                                <FormGroup className="mb-2">
                                                    <Form.Label>
                                                        Informe o caminho do arquivo executavel
                                                        
                                                        </Form.Label>
                                                    <Form.Control id="executable" onChange={(e) => executablePath(e.target.value)}></Form.Control>
                                                </FormGroup>
                                                <p>* Execução do scorm acontecerá em segundo plano</p>
                                            </Col>
                                        )}

                                    </>
                                ) : (
                                    fileUpload.type && fileUpload?.type.indexOf('pdf') !== -1 ? (
                                        <Col sm={12}>
                                            <FormGroup className="mb-2">
                                                <Form.Label>Escolha quantas página mostrar no preview do objeto</Form.Label>
                                                <Form.Control id="preview"></Form.Control>
                                            </FormGroup>
                                        </Col>
                                    ) : (<></>)
                                )}

                            </Row>
                        </>
                    ) : (<></>)}
                </>) : (
                    <Row className="h-100">
                        <div style={{ minHeight: 'calc(100vh - 270px)', padding: 32 }}>
                            <FileViewer key={1} fileType={itemData?.format} isGeneratingScorm={isGeneratingScorm} filePath={itemData?.url_path} preview_index={itemData?.preview_file_index} preview_url={itemData?.preview_url}></FileViewer>
                        </div>
                    </Row>
                )}

            </CardDescription>
        </>
    )
}